import { useTranslation } from 'react-i18next';
import { AccountsSearchColumn } from '../components/AccountsSearchColumn';
import { UsersSearchColumn } from '../components/UsersSearchColumn';
import { DevicesSearchColumn } from '../components/DevicesSearchColumn';

/**
 * Customers landing page — three independent search columns.
 *
 * Accounts / Users ride `users.emails.address_1`; Devices uses Atlas Search
 * `deviceSearch` + `UUID_1` exact match. Each column owns its own local state;
 * URL is deliberately NOT used (three boxes keyed by URL params is noisy and
 * deep-linking into a specific multi-column search isn't a staff workflow).
 */
export function CustomersPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6 p-6" data-testid="customers-page">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-bold text-foreground">{t('Customers')}</h1>
        <p className="text-sm text-muted-foreground">
          {t(
            'Search accounts by owner email or domain, users by email or domain, or devices by name or UUID.',
          )}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <AccountsSearchColumn />
        <UsersSearchColumn />
        <DevicesSearchColumn />
      </div>
    </div>
  );
}
